export const data = [
  {
    photographer: 'Lucía Montenegro',
    src: {
      large:
        'https://images.pexels.com/photos/12185664/pexels-photo-12185664.jpeg?auto=compress&cs=tinysrgb&h=650&w=940',
    },
  },
  {
    photographer: 'Veronika Bykovich',
    src: {
      large:
        'https://images.pexels.com/photos/12185506/pexels-photo-12185506.jpeg?auto=compress&cs=tinysrgb&h=650&w=940',
    },
  },
  {
    photographer: 'ἐμμανυελ  ',
    src: {
      large:
        'https://images.pexels.com/photos/12182835/pexels-photo-12182835.jpeg?auto=compress&cs=tinysrgb&h=650&w=940',
    },
  },
  {
    photographer: 'Eugene Golovesov',
    src: {
      large:
        'https://images.pexels.com/photos/12180544/pexels-photo-12180544.jpeg?auto=compress&cs=tinysrgb&h=650&w=940',
    },
  },
  {
    photographer: 'op23',
    src: {
      large:
        'https://images.pexels.com/photos/12166061/pexels-photo-12166061.jpeg?auto=compress&cs=tinysrgb&h=650&w=940',
    },
  },
  {
    photographer: 'Nina  Hill',
    src: {
      large:
        'https://images.pexels.com/photos/12168556/pexels-photo-12168556.jpeg?auto=compress&cs=tinysrgb&h=650&w=940',
    },
  },
  {
    photographer: 'Jonathan Borba',
    src: {
      large:
        'https://images.pexels.com/photos/12173281/pexels-photo-12173281.jpeg?auto=compress&cs=tinysrgb&h=650&w=940',
    },
  },
  {
    photographer: 'Enrique Hoyos',
    src: {
      large:
        'https://images.pexels.com/photos/12172737/pexels-photo-12172737.jpeg?auto=compress&cs=tinysrgb&h=650&w=940',
    },
  },
  {
    photographer: 'Malik Skydsgaard',
    src: {
      large:
        'https://images.pexels.com/photos/12132217/pexels-photo-12132217.jpeg?auto=compress&cs=tinysrgb&h=650&w=940',
    },
  },
  {
    photographer: 'Fidan Nazim qizi',
    src: {
      large:
        'https://images.pexels.com/photos/12155886/pexels-photo-12155886.jpeg?auto=compress&cs=tinysrgb&h=650&w=940',
    },
  },
  {
    photographer: 'Philip Warp',
    src: {
      large:
        'https://images.pexels.com/photos/12151766/pexels-photo-12151766.jpeg?auto=compress&cs=tinysrgb&h=650&w=940',
    },
  },
  {
    photographer: 'Poyee Tsang',
    src: {
      large:
        'https://images.pexels.com/photos/12139617/pexels-photo-12139617.jpeg?auto=compress&cs=tinysrgb&h=650&w=940',
    },
  },
  {
    photographer: 'Poyee Tsang',
    src: {
      large:
        'https://images.pexels.com/photos/12139755/pexels-photo-12139755.jpeg?auto=compress&cs=tinysrgb&h=650&w=940',
    },
  },
  {
    photographer: 'Blue Arauz',
    src: {
      large:
        'https://images.pexels.com/photos/12151090/pexels-photo-12151090.jpeg?auto=compress&cs=tinysrgb&h=650&w=940',
    },
  },
  {
    photographer: 'Eugene Golovesov',
    src: {
      large:
        'https://images.pexels.com/photos/12142950/pexels-photo-12142950.jpeg?auto=compress&cs=tinysrgb&h=650&w=940',
    },
  },
  {
    photographer: 'Martino Grua',
    src: {
      large:
        'https://images.pexels.com/photos/12142729/pexels-photo-12142729.jpeg?auto=compress&cs=tinysrgb&h=650&w=940',
    },
  },
  {
    photographer: 'Malik Skydsgaard',
    src: {
      large:
        'https://images.pexels.com/photos/12132204/pexels-photo-12132204.jpeg?auto=compress&cs=tinysrgb&h=650&w=940',
    },
  },
  {
    photographer: 'Malik Skydsgaard',
    src: {
      large:
        'https://images.pexels.com/photos/12132208/pexels-photo-12132208.jpeg?auto=compress&cs=tinysrgb&h=650&w=940',
    },
  },
  {
    photographer: 'Alyona Pastukhova',
    src: {
      large:
        'https://images.pexels.com/photos/12136490/pexels-photo-12136490.jpeg?auto=compress&cs=tinysrgb&h=650&w=940',
    },
  },
  {
    photographer: 'Rizky Sabriansyah',
    src: {
      large:
        'https://images.pexels.com/photos/12128696/pexels-photo-12128696.jpeg?auto=compress&cs=tinysrgb&h=650&w=940',
    },
  },
  {
    photographer: 'Kris Møklebust',
    src: {
      large:
        'https://images.pexels.com/photos/12143040/pexels-photo-12143040.jpeg?auto=compress&cs=tinysrgb&h=650&w=940',
    },
  },
  {
    photographer: 'op23',
    src: {
      large:
        'https://images.pexels.com/photos/12125084/pexels-photo-12125084.jpeg?auto=compress&cs=tinysrgb&h=650&w=940',
    },
  },
  {
    photographer: '7inchs',
    src: {
      large:
        'https://images.pexels.com/photos/12092806/pexels-photo-12092806.jpeg?auto=compress&cs=tinysrgb&h=650&w=940',
    },
  },
  {
    photographer: 'Taylor Marx',
    src: {
      large:
        'https://images.pexels.com/photos/12089012/pexels-photo-12089012.jpeg?auto=compress&cs=tinysrgb&h=650&w=940',
    },
  },
  {
    photographer: 'Jair Hernandez',
    src: {
      large:
        'https://images.pexels.com/photos/12087895/pexels-photo-12087895.jpeg?auto=compress&cs=tinysrgb&h=650&w=940',
    },
  },
  {
    photographer: 'Elena Rubtsova',
    src: {
      large:
        'https://images.pexels.com/photos/12082485/pexels-photo-12082485.jpeg?auto=compress&cs=tinysrgb&h=650&w=940',
    },
  },
  {
    photographer: 'Elena Rubtsova',
    src: {
      large:
        'https://images.pexels.com/photos/12082493/pexels-photo-12082493.jpeg?auto=compress&cs=tinysrgb&h=650&w=940',
    },
  },
  {
    photographer: 'GEORGE KASCHEEV',
    src: {
      large:
        'https://images.pexels.com/photos/12052041/pexels-photo-12052041.jpeg?auto=compress&cs=tinysrgb&h=650&w=940',
    },
  },
  {
    photographer: 'Trinity LaKose',
    src: {
      large:
        'https://images.pexels.com/photos/12050692/pexels-photo-12050692.jpeg?auto=compress&cs=tinysrgb&h=650&w=940',
    },
  },
  {
    photographer: 'Omar Zetina',
    src: {
      large:
        'https://images.pexels.com/photos/12046302/pexels-photo-12046302.jpeg?auto=compress&cs=tinysrgb&h=650&w=940',
    },
  },
  {
    photographer: 'Withsonya_',
    src: {
      large:
        'https://images.pexels.com/photos/12123082/pexels-photo-12123082.jpeg?auto=compress&cs=tinysrgb&h=650&w=940',
    },
  },
  {
    photographer: 'Leah Kelley',
    src: {
      large:
        'https://images.pexels.com/photos/12128380/pexels-photo-12128380.jpeg?auto=compress&cs=tinysrgb&h=650&w=940',
    },
  },
  {
    photographer: 'Leah Kelley',
    src: {
      large:
        'https://images.pexels.com/photos/12128383/pexels-photo-12128383.jpeg?auto=compress&cs=tinysrgb&h=650&w=940',
    },
  },
  {
    photographer: 'Usman ARJ',
    src: {
      large:
        'https://images.pexels.com/photos/12125024/pexels-photo-12125024.jpeg?auto=compress&cs=tinysrgb&h=650&w=940',
    },
  },
  {
    photographer: 'Iury Bessa',
    src: {
      large:
        'https://images.pexels.com/photos/12118868/pexels-photo-12118868.jpeg?auto=compress&cs=tinysrgb&h=650&w=940',
    },
  },
  {
    photographer: 'op23',
    src: {
      large:
        'https://images.pexels.com/photos/12118291/pexels-photo-12118291.jpeg?auto=compress&cs=tinysrgb&h=650&w=940',
    },
  },
];

export default data;
